// extracted by mini-css-extract-plugin
export default {"linksWrap":"TabPageLayout_linksWrap__bhNgq","link":"TabPageLayout_link__zVQUC","linkActive":"TabPageLayout_linkActive__nEIkT","content":"TabPageLayout_content__1NQfs"};